const FaChevronRight = (props: { className?: string }) => {
  return (
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" className={`svg-inline--fa fa-chevron-right ${props.className ?? ""}`} role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path></svg>
  );
}

export default FaChevronRight;